import { useQuery } from "../../Utils/utils"

export const useCreditsPageQuery = (search) => {
  const query = useQuery(search)
  return {
    openCreditRequestID: query.get("open_credit_request"),
    openCreditResubmit: query.get("open_credit_resubmit"),
    openCreditID: query.get("open_credit"),
    business_account_id: query.get("business_account_id"),
    attach: query.get("attach"),
    folder: query.get("folder"),
    baId: query.get("id")
  }
}
